<template>
  <el-dialog title="指定客服" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form class="el-cus" ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="客服：" prop="name" class="width100">
        <el-select v-model="value" filterable placeholder="请选择客服" :popper-append-to-body="false" :remote-method="remoteMethod" :loading="loading">
          <el-option v-for="item in serviceOptions" :key="item.id" :label="item.realName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>

import custServiceStaffApi from '@/api/customer/custServiceStaff'
import custServiceGuestbookApi from '@/api/customer/custServiceGuestbook'

export default {
  data() {
    return {
      value: '',
      formVisible: false,
      serviceOptions: [],
      id: ''
    }
  },
  created() {
  },
  methods: {
    getList() {
      custServiceStaffApi.fetchForList().then(({ data }) => {
        this.serviceOptions = data
        this.formVisible = true
      })
    },
    handleService(row) {
      this.id = row.id
      this.value = ''
      if (this.serviceOptions.length > 0) return this.formVisible = true
      this.getList()
    },
    doCreate() {
      if (!this.value) return this.$message.error('请选择客服')
      custServiceGuestbookApi.assignKeFu({custServiceStaffId: this.value,id:this.id }).then(res => {
        if (res.code === '0') {
          this.formVisible = false
          this.$emit('created')
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.el-cus {
  padding: 0 15px;
}
::v-deep .el-select-dropdown.el-popper {
  max-width: 600px !important;
}
::v-deep .el-select {
  width: 100%;
}
</style>
